'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _reactisForms = require('reactis-forms');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Glyphicon = require('./Glyphicon');

var _Glyphicon2 = _interopRequireDefault(_Glyphicon);

var _reactBootstrap = require('react-bootstrap');

var _components = {
	_$Checkbox: {
		displayName: 'Checkbox'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Checkbox = (function (_React$Component) {
	_inherits(Checkbox, _React$Component);

	function Checkbox() {
		_classCallCheck(this, _Checkbox);

		_React$Component.apply(this, arguments);
	}

	Checkbox.prototype.getError = function getError() {
		return this.props.error && this.props.error[0];
	};

	Checkbox.prototype.renderInputGroup = function renderInputGroup(children) {

		var tooltip = this.props.help ? _react2['default'].createElement(
			_reactBootstrap.Tooltip,
			{ id: this.props.help },
			this.props.help
		) : null;
		var help = this.props.help ? _react2['default'].createElement(
			_reactBootstrap.OverlayTrigger,
			{ key: 'help', placement: 'top', overlay: tooltip },
			_react2['default'].createElement('span', { className: 'fa fa-question-circle position-right', style: { top: -1 } })
		) : null;

		return help ? _react2['default'].createElement(
			'div',
			{ key: 'group' },
			children,
			help
		) : children;
	};

	Checkbox.prototype.renderWrapper = function renderWrapper(children) {

		var classes = {
			'has-error': this.getError()
		};

		return _react2['default'].createElement(
			'span',
			{ className: _classnames2['default'](classes, this.props.wrapperClassName), key: 'wrapper' },
			children
		);
	};

	Checkbox.prototype.renderLabel = function renderLabel(children) {
		var classes = {
			'control-label': false
		};
		classes[this.props.labelClassName] = this.props.labelClassName;

		return this.props.label ? _react2['default'].createElement(
			'label',
			{ htmlFor: this.props.id, className: _classnames2['default'](classes), key: 'label' },
			children,
			this.props.label
		) : children;
	};

	Checkbox.prototype.renderInput = function renderInput() {
		return _react2['default'].createElement(_reactisForms.Checkbox, _extends({}, this.props, { className: this.props.className, key: 'input' }));
	};

	Checkbox.prototype.renderError = function renderError() {
		var error = this.getError();
		return error ? _react2['default'].createElement(
			'span',
			{ className: 'error-block', key: 'error' },
			error
		) : null;
	};

	Checkbox.prototype.renderChildren = function renderChildren() {
		return this.renderWrapper([this.renderInputGroup(this.renderInput()), this.renderError()]);
	};

	Checkbox.prototype.render = function render() {
		var children = this.renderChildren();
		return _react2['default'].createElement(
			'span',
			null,
			children
		);
	};

	var _Checkbox = Checkbox;
	Checkbox = _wrapComponent('_$Checkbox')(Checkbox) || Checkbox;
	return Checkbox;
})(_react2['default'].Component);

exports['default'] = Checkbox;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/Checkbox.js
 ** module id = 1031
 ** module chunks = 1
 **/